import { D as a } from "./DropdownDivider-c57dbbbe.js";
import { b as A, a as E } from "./DropdownDivider-c57dbbbe.js";
import { F as d } from "./FormCheck-89a11513.js";
import { resolveComponent as r, openBlock as i, createBlock as s, withCtx as c, createVNode as u } from "vue";
import { _ as f } from "./_plugin-vue_export-helper-dad06003.js";
import "./CardVideo-a346405d.js";
import "./glightbox-13d8fc52.js";
import "./FormRichText.model-53e072ea.js";
import { D as H } from "./DropdownMenu-cf91b06e.js";
import { D as K } from "./DropdownTextDivider-98e5ec60.js";
import "./CheckIcon-91388c05.js";
import "./HelpIcon-2069ddad.js";
import "./ButtonPlay-d3872713.js";
import "./XIcon-e21df3cc.js";
import "./useNotificationHandler.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ButtonCloseSm-209b27c6.js";
import "./PreloaderIcon-b44be854.js";
import "./ChevronLeftIcon-b6affe9b.js";
import "./_commonjsHelpers-10dfc225.js";
const D = {
  components: {
    DropdownItem: a,
    FormCheck: d
  },
  props: {
    modelValue: Boolean,
    label: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(o) {
        this.$emit("update:modelValue", o);
      }
    }
  }
};
function _(o, e, m, w, x, t) {
  const p = r("FormCheck"), l = r("DropdownItem");
  return i(), s(l, null, {
    default: c(() => [
      u(p, {
        modelValue: t.model,
        "onUpdate:modelValue": e[0] || (e[0] = (n) => t.model = n),
        class: "w-full",
        label: m.label
      }, null, 8, ["modelValue", "label"])
    ]),
    _: 1
  });
}
const j = /* @__PURE__ */ f(D, [["render", _]]);
export {
  j as DropdownCheckItem,
  A as DropdownDivider,
  a as DropdownItem,
  E as DropdownList,
  H as DropdownMenu,
  K as DropdownTextDivider
};
